import React, { useRef } from 'react'
import { Card, Loader, Typography } from 'src/components/common';
import { UploadIcon } from 'src/components/common/common.icons';

export default function UploadField({ title, instructionText = '', accept = ".bmp,.jpg,.jpeg,.png", onUpload, loading = false, required = false }: { required?: boolean, title: string, accept?: string, instructionText?: string, onUpload: (data: any, e?: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLDivElement>) => void, loading?: boolean }) {
    const dragDropRef = useRef<HTMLDivElement>(null);
    const uploadImageRef = useRef<HTMLInputElement>(null);
    const openImageFileManager = async () => {
        if (uploadImageRef.current) {
            uploadImageRef.current.click();
        }
    };
    return (
        <Card className="dynamic-field">
            <div className="dynamic-field__header w-100">
                <Typography as="span" variant="caption" className='w-100' fontWeight="semiBold">
                    <div className='d-flex justify-content-between'>
                        <span>{title} {required && <span style={{ color: 'red' }}>*</span>} </span>
                        <span style={{ color: '#6E6E6E', fontSize: '12px' }}>{instructionText}</span>
                    </div>
                </Typography>
            </div>
            <div
                className="dynamic-field__upload-file flex-row align-items-center"
                draggable
                ref={dragDropRef}
                onDrop={(e) => {
                    e.preventDefault();
                    onUpload(e.dataTransfer.files, e);
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                }}
                onClick={openImageFileManager}
            >
                {!loading && <>
                    <span className="dynamic-field__upload-file__drag-drop">
                        <UploadIcon />
                        <Typography as="p" variant="body-2" fontWeight="regular">
                            Drag and drop your logo
                        </Typography>
                        <input
                            type="file"
                            hidden
                            ref={uploadImageRef}
                            accept={accept}
                            className="select-post-image"
                            onChange={(e) => {
                                onUpload(e.target.files, e);
                            }}
                        />
                    </span>
                    <Typography as="p" variant="body-2" fontWeight="regular">
                        or
                    </Typography>
                    <Typography
                        as="span"
                        variant="body-2"
                        fontWeight="medium"
                        className="dynamic-field__upload-file__browse"

                    >
                        Browse on your device
                    </Typography>
                </>}
                {loading && <Loader />}
            </div>

            {/* {<ErrorMessage message={errors?.[id]} />} */}
        </Card>
    )
}
